export default "__VITE_ASSET__lPV8HXqP__"